export default "__VITE_ASSET__D$2yOGc3__"